import React from "react";
import { Zap, Truck, ShieldCheck } from "lucide-react";
import { SHOP } from "@/constants/testIds";

const messages = [
  { icon: Truck, text: "Fastest delivery across the city" },
  { icon: Zap, text: "Free shipping on orders above ₹500" },
  { icon: ShieldCheck, text: "100% genuine, QR verified" },
  { icon: Truck, text: "Pay on Delivery available" },
];

export default function AnnouncementBar() {
  return (
    <div
      data-testid={SHOP.announcementBar}
      className="bg-[#0056D2] text-white text-xs sm:text-sm font-semibold overflow-hidden"
    >
      <div className="flex items-center gap-12 py-2 animate-marquee whitespace-nowrap">
        {[...messages, ...messages, ...messages].map((m, i) => {
          const Icon = m.icon;
          return (
            <span key={`${m.text}-${i}`} className="inline-flex items-center gap-2 px-4">
              <Icon size={14} strokeWidth={2.5} className="text-[#FFD700]" />
              {m.text}
            </span>
          );
        })}
      </div>
    </div>
  );
}
